import React from 'react';

import MediaBigPhoto from './component';

export default React.memo(MediaBigPhoto);
